import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlahService } from '@headpower/blah-ng';

export class NotificationData {
  description: string;
  translate: boolean;
}

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.css']
})
export class NotificationDialogComponent {
  public description: string = "";
  public translate: boolean;
  public title: string;

  constructor(
    private dialogRef: MatDialogRef<NotificationDialogComponent>,
    private blahService: BlahService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.translate = this.data && this.data.translate;
    this.description = this.translate ? this.blahService.blah(this.data.description, this.blahService.currentLocale) : this.data.description;

    dialogRef.afterOpened().subscribe(s => {
      if (this.data && this.data.description) {
        this.description = this.data.description;
      } else {
        throw new Error("NotificationDialogs description was missing!");
      }
    }
    );
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}

